module.exports = "/call-frontend/img/pci_logo_orange.6df7ff62.png";